import SkeletonLoader from '@/Layout/SkeletonLoader'

const BorderSelect = (props) => {
    const { selectProps, customClass, children, skeletonLoading, onChange } = props
    return (
        <>
            {skeletonLoading ? <SkeletonLoader height={54} rows={1} /> :
                <select {...selectProps} onChange={onChange} className={`${customClass} appearance-none border border-neutral-200 rounded-full w-full py-2.5 px-4 pr-10 text-sm text-neutral-700 font-medium placeholder:text-neutral-400 placeholder:font-normal focus:outline-none focus:border-primary/60 focus:ring-4 focus:ring-primary/15 focus-visible:outline-none bg-[url('/assets/images/select-arrow.svg')] bg-no-repeat bg-[95%] bg-white transition-all duration-150 *:bg-white *:px-2 *:py-1`}>
                    {children}
                </select>
            }
        </>
    )
}

export default BorderSelect
